import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import * as userActions from "../../../../actions/user.actions";
import * as adminActions from "../../../../actions/admin.actions";

import AdminUsers from "../components/AdminUsers";

import parseAdvancedSearch from "../../../../utils/parseAdvancedSearch";
import parseFilters from "../../../../utils/parseFilters";
import {
  decodeSearchParams,
  getFinalQueryString
} from "../../../../utils/parseQueries";

class AdminUsersContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      advancedSearch: [],
      filters: []
    };
  }

  componentWillMount() {
    this.setState({ ...decodeSearchParams(this.props.location.search) });
  }

  componentDidMount() {
    const filters = getFinalQueryString(
      parseFilters(this.state.filters) +
        parseAdvancedSearch(this.state.advancedSearch)
    );

    this.props.userActions.getAdminMembers(filters);
    this.props.userActions.getAdminMembersCSVData(filters);
  }

  render() {
    return (
      <AdminUsers
        advancedSearch={this.state.advancedSearch}
        filters={this.state.filters}
        getCsvData={this.props.userActions.getAdminMembersCSVData}
        getTable={this.props.userActions.getAdminMembers}
        history={this.props.history}
        loading={this.props.loading}
        numberOfPages={this.props.members.last_page}
        page={this.props.page}
        paginationCount={this.props.paginationCount}
        setPage={this.props.adminActions.setPage}
        setSort={this.props.adminActions.setSort}
        sortData={this.props.sortData}
        users={this.props.members.data || []}
        users_csv={_.get(this.props, "members_csv.data") || []}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    loading: state.user.loadingGetAdminMembers,
    members: state.user.adminMembers,
    members_csv: state.user.adminMembersCsv,
    page: state.admin.pagination.users,
    paginationCount: adminActions.getPaginationCounts(state.admin.pagination),
    sortData: state.admin.sorting.users
  };
};

const mapDispatchToProps = dispatch => {
  return {
    adminActions: bindActionCreators(adminActions, dispatch),
    userActions: bindActionCreators(userActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminUsersContainer);



// WEBPACK FOOTER //
// ./src/routes/admin/users/containers/AdminUsersContainer.js